import { useEffect, useMemo, useState } from "react";
import TakeOffSiteBox from "../../components/TakeOffSiteBox";
import {FEATURED_TAKE_OFF_SITE, TAKE_OFF_SITES} from "../../constants";
import {useTranslation} from "react-i18next";
import EUChampionshipSiteBox from "../../components/EUChampionshipSiteBox";
import Footer from "../../components/Footer";
import { getNow } from "../../services/api";
import { getFlightSafetyStatus } from "../../utils/flightSafety";
import { useStationSectors } from "../../contexts/StationSectorsContext";

const HomePage = () => {
    const {t} = useTranslation();
    const [weatherBySite, setWeatherBySite] = useState({});
    const { byId: sectorsById } = useStationSectors();

    useEffect(() => {
        let cancelled = false;
        Promise.allSettled(
            TAKE_OFF_SITES.map((site) => getNow(site.id))
        ).then((results) => {
            if (cancelled) return;
            const map = {};
            results.forEach((r, i) => {
                map[TAKE_OFF_SITES[i].id] = r.status === 'fulfilled' ? r.value : null;
            });
            setWeatherBySite(map);
        });
        return () => { cancelled = true; };
    }, []);

    const orderedSites = useMemo(() => {
        return [...TAKE_OFF_SITES].sort((a, b) => {
            const aOffline = getFlightSafetyStatus(a, weatherBySite[a.id], sectorsById[a.id]).isOffline;
            const bOffline = getFlightSafetyStatus(b, weatherBySite[b.id], sectorsById[b.id]).isOffline;
            if (aOffline && !bOffline) return 1;
            if (!aOffline && bOffline) return -1;
            return 0;
        });
    }, [weatherBySite, sectorsById]);

    return (
        <div className="bg-zinc-100 dark:bg-slate-900 min-h-screen flex flex-col">
            <div className="flex-grow">
                <div className="container mx-auto px-3 sm:px-4 flex flex-col pt-6 sm:pt-8 pb-8 sm:pb-10">
                    {FEATURED_TAKE_OFF_SITE &&
                        <>
                    <h1 className="text-center text-2xl sm:text-3xl font-bold text-zinc-800 dark:text-slate-100 mb-4 sm:mb-6 px-2">{t('16th FAI PARAGLIDING EUROPEAN CHAMPIONSHIP')}</h1>
                    <EUChampionshipSiteBox key={"EUChampionshipSiteBox"} takeOffSite={FEATURED_TAKE_OFF_SITE}/>
                    </>
                    }
                    <div className="text-center mt-8 sm:mt-12 mb-6 sm:mb-8 px-2">
                        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-2 sm:mb-3">
                            {t('Live Weather at Takeoff Sites')}
                        </h2>
                        <p className="text-gray-600 dark:text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">
                            {t('Real-time weather conditions from meteorological stations across paragliding sites in Serbia')}
                        </p>
                    </div>
                    <div className="flex flex-wrap justify-center">
                        {orderedSites.map((site) => (
                            <TakeOffSiteBox
                                key={site.slug}
                                takeOffSite={site}
                                weatherData={weatherBySite[site.id]}
                                controlled
                            />
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>

    );
};

export default HomePage;
